module.exports = __webpack_public_path__ + "static/media/image-2.650981e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/StateofSocial/image-2.jpg
// module id = 478
// module chunks = 0